/**
 * Fullscreen sorpresa: $99.99, solo botón comprar, fondo = Mux playback ID.
 * Route: /sorpresa
 * Tracking: metadata source anaafernandez.
 *
 * Playback ID: primero desde /api/public-playback-ids (runtime, key SORPRESA_PLAYBACK_ID en Railway),
 * luego VITE_SORPRESA_PLAYBACK_ID (build time), luego fallback local.
 */

import { useEffect, useState } from "react";
import MuxVideoPlayerWithCTA from "@/components/MuxVideoPlayerWithCTA";
import { useCurrentTemplate } from "@/contexts/CurrentTemplateContext";

const FALLBACK_PLAYBACK_ID = "PhCWZCQmP6hVfAuCokc00jipal401oe2M38PVvBW9NSas";

/** Valor en build time (VITE_SORPRESA_PLAYBACK_ID) o fallback */
const buildTimePlaybackId =
  (import.meta.env.VITE_SORPRESA_PLAYBACK_ID as string)?.trim() || FALLBACK_PLAYBACK_ID;

export default function FullscreenSorpresa() {
  const [playbackId, setPlaybackId] = useState(buildTimePlaybackId);
  const { setTemplateName } = useCurrentTemplate();

  // /sorpresa es independiente: no aplicar BaseTemplate ni otro template de la home
  useEffect(() => {
    setTemplateName(null);
    return () => setTemplateName(null);
  }, [setTemplateName]);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalHeight = document.body.style.height;
    const originalPosition = document.body.style.position;
    const originalWidth = document.body.style.width;
    document.body.style.overflow = "hidden";
    document.body.style.height = "100dvh";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.height = originalHeight;
      document.body.style.position = originalPosition;
      document.body.style.width = originalWidth;
    };
  }, []);

  // Runtime: usar key definida en Railway (SORPRESA_PLAYBACK_ID) sin necesidad de redeploy
  useEffect(() => {
    const base = typeof window !== "undefined" ? window.location.origin : "";
    if (!base) return;
    fetch(`${base}/api/public-playback-ids`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { sorpresa?: string } | null) => {
        const id = data?.sorpresa?.trim();
        if (id) setPlaybackId(id);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="w-full h-dvh max-h-dvh overflow-hidden bg-black">
      <MuxVideoPlayerWithCTA
        playbackId={playbackId}
        overridePackId="sorpresa"
        variant="fullscreen"
        displayMode="reel"
        conversionReel={true}
        ctaLabel="Descubrir"
      />
    </div>
  );
}
